import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import moment from 'moment';

@Component({
  selector: 'app-availability-calendar',
  templateUrl: './availability-calendar.component.html',
  styleUrls: ['./availability-calendar.component.scss'],
})
export class AvailabilityCalendarComponent implements OnInit {
  @Input() fromDate;
  @Input() toDate;
  @Input() configuredWorkHours;
  @Input() loading = false;
  @Input() showFunctionalityInfo = true;
  @Output() updateDateSelected = new EventEmitter();
  @Output() getMonthData = new EventEmitter();
  public dates = [];
  public selectedDay = 0;

  constructor() {}

  ngOnInit() {
    //this.populateDates();
    this.loading = true;
  }

  ngOnChanges() {
    this.populateDates();
  }

  populateDates() {
    var i = 0;
    var dates = [];
    var minWeek =
      moment(this.fromDate).weekday() == 0
        ? moment(this.fromDate).add('day', -1).week()
        : moment(this.fromDate).week();
    var maxWeek = moment(this.toDate).week();

    if (maxWeek == 1 && moment(this.fromDate).month() + 1 == 12) {
      maxWeek = moment(this.toDate).isoWeeksInYear() + 1;
    }
    for (
      var date = moment(this.fromDate);
      moment(date).unix() <= moment(this.toDate).unix();
      date = moment(date).add(1, 'days')
    ) {
      var startTime = '00:00';
      var endTime = '00:00';
      var onlineHours = 0;
      var workingHours = 0;
      var working = false;
      var defaultHours = false;
      var found = this.configuredWorkHours
        .filter((x) => {
          return (
            moment(x.date).format('YYYY-MM-DD') === date.format('YYYY-MM-DD')
          );
        })
        .pop();

      if (found) {
        startTime = found.startTime;
        endTime = found.endTime;
        onlineHours = found.onlineHours;
        workingHours = Math.round(
          moment('1970-01-01T' + found.endTime).diff(
            moment('1970-01-01T' + found.startTime),
            'minutes',
          ) / 60,
        );
        working = found.isWorking && true;
        defaultHours = found.default && true;
      }

      dates.push({
        date: date.format('YYYY-MM-DD'),
        dayOfWeek: moment(date).weekday(),
        dayOfMonth: moment(date).date(),
        weekOfYear:
          moment(date).week() == 1 && moment(this.fromDate).month() + 1 == 12
            ? moment(this.toDate).isoWeeksInYear() + 1
            : moment(date).week(),
        working: working,
        workingHours: workingHours,
        startTime: startTime,
        endTime: endTime,
        onlineHours: onlineHours,
        defaultHours: defaultHours,
        id: found && found.id ? found.id : 0,
      });

      i++;
      if (i > 60) break;
    }

    var x = new Array(maxWeek - minWeek + 1);
    for (var i = 0; i < x.length; i++) {
      x[i] = new Array(7);
      for (var j = 0; j < x[i].length; j++) {
        var found = dates
          .filter((x) => {
            return x.weekOfYear === i + minWeek && x.dayOfWeek === j;
          })
          .pop();
        if (!found) {
          x[j == 0 && i > 0 ? i - 1 : i][j == 0 ? 6 : j - 1] = {};
        } else {
          x[j == 0 && i > 0 ? i - 1 : i][j == 0 ? 6 : j - 1] = found;
        }
      }
    }

    this.dates = x;
  }

  nextMonth() {
    this.selectedDay = 0;
    this.fromDate = moment(this.fromDate).add('month', 1);
    this.toDate = moment(this.fromDate).endOf('month');
    this.populateDates();
    this.getMonthData.emit({
      fromDate: this.fromDate.toDate(),
      toDate: this.toDate.toDate(),
    });
  }

  prevMonth() {
    this.selectedDay = 0;
    this.fromDate = moment(this.fromDate).add('month', -1);
    this.toDate = moment(this.fromDate).endOf('month');
    this.populateDates();
    this.getMonthData.emit({
      fromDate: this.fromDate.toDate(),
      toDate: this.toDate.toDate(),
    });
  }

  daySelected(day) {
    this.updateDateSelected.emit(day);
    this.selectedDay = day.dayOfMonth;
  }

  updateDateToggle(day) {
    day.working = !day.working;
    this.updateDateSelected.emit(day);
    if (day.working) {
      this.selectedDay = day.dayOfMonth;
    } else {
      this.selectedDay = 0;
    }
  }
}
